import { __awaiter, __generator } from "tslib";
import { createTooltipDriver } from '../../primitives/tooltip/driver';
import { compKey } from './key';
export var createSimpleAudioPlayerDriver = function (wrapper, global) {
    var base = wrapper.$("." + compKey);
    var tooltipDriver = createTooltipDriver(wrapper, global);
    return {
        getTimeString: function () { return base.$('.time').text(); },
        isPlaying: function () { return base.$('.play-icon .pause').exists(); },
        clickPlayPause: function () { return base.$('.play-icon').click(); },
        clickAnotationByIdx: function (idx) { return base.$$('.annotation-wrapper').get(idx).click(); },
        hoverAnotationByIdx: function (idx) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = tooltipDriver.tooltipTriggerBase
                            .mouse).moveTo;
                        return [4 /*yield*/, base.$$('.annotation-wrapper').get(idx)];
                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                }
            });
        }); },
        tooltipDriver: tooltipDriver,
        base: base,
        global: global
    };
};
//# sourceMappingURL=driver.js.map